import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Messages Redux States
import { GET_ADITIONAL_FIELDS, SAVE_ADITIONAL_FIELDS } from "./actionTypes";
import { aditionalFieldsError, setAditionalFields, setAditionalFieldsSuccess } from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getAditionalFields({ payload: chatId }) {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_URL}/additional-fields-by-ticket/${chatId}`,
      {
        headers: { apiVersion: "3" },
      }
    );

    if (response.status === 200) {
      yield put(setAditionalFields(chatId, response.data.data));   
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Get Aditional Fields error";
    yield put(aditionalFieldsError({ action: "get_info", message: message }));
  }
}

function* saveAditionalFields({payload: {chatId, data}}) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/conversations/${chatId}/fields`,{additionalFields: data}
    );

    if (response.status === 200) {
      yield put(setAditionalFieldsSuccess(chatId, data));
    } else {
      throw response.data;
    }    
  } catch (error) {
    let message = "Could not save changes please try again";
    yield put(aditionalFieldsError({ action: "save_fields", message: message }));
  }
}

export function* watchAditionalFields() {
  yield takeEvery(GET_ADITIONAL_FIELDS, getAditionalFields);
}
export function* watchSaveAditionalFields() {
  yield takeEvery(SAVE_ADITIONAL_FIELDS, saveAditionalFields);
}
function* authSaga() {
  yield all([fork(watchAditionalFields), fork(watchSaveAditionalFields)]);
}

export default authSaga;
